export default __webpack_public_path__ + "static/media/amazon.dcf378d0.svg";